import { css } from '@emotion/core'
import { GatsbyImage } from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import React from 'react'

import { breakpoints } from '../constants/breakPoints'
import Block from './Block'
import { DemoButton } from './Button'
import Image from './Image'
import SvgIcon from './SvgIcon'

export const TemplatesIntro: React.FC<{
  heading: string
  description?: string
  gatsbyImageSrc?: any
  imageSrc?: string
  buttonText?: string
  withoutCTA?: boolean
}> = ({ heading, description, gatsbyImageSrc, imageSrc, buttonText, withoutCTA = false }) => {
  return (
    <Block
      className="blue-gradient-bg"
      noBreakForTablet
      columns={2}
      columnGap={4.5}
      columnsTemplate="auto 235px"
      css={containerStyle(withoutCTA)}
    >
      <div>
        <h1 className="heading2">{parse(heading)}</h1>
        {description && <p className="subtitle">{parse(description)}</p>}
        {!withoutCTA && (
          <div css={buttonContainerStyle}>
            <DemoButton buttonText={buttonText} />
          </div>
        )}
      </div>
      {(gatsbyImageSrc || imageSrc) && (
        <div css={imageContainerStyle}>
          <SvgIcon src="templates/blue-bg-checkmark" css={checkmarkStyle} />
          {gatsbyImageSrc && (
            <GatsbyImage image={gatsbyImageSrc.gatsbyImageData} alt={heading} css={imageStyle} loading="eager" />
          )}
          {imageSrc && <Image src={imageSrc} alt={heading} css={imageStyle} loading="eager" />}
          <SvgIcon src="templates/white-rectangle" css={whiteRectangleStyle} />
          <SvgIcon src="templates/blue-rectangle" css={blueRectangleStyle} />
        </div>
      )}
    </Block>
  )
}

const containerStyle = (withoutCTA: boolean) => css`
  margin-bottom: 6rem;
  padding: 1rem 3rem;
  border-radius: 0.5rem;

  .heading2 {
    margin-bottom: ${withoutCTA ? '1.5rem' : '0.5rem'};
  }

  @media screen and (max-width: ${breakpoints.medium}px) {
    margin: 0 -1.5rem 4rem;
    padding: 2rem 1.5rem;
    border-radius: 0;
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    row-gap: 0;

    .heading2 {
      margin-bottom: 1rem;
    }

    .heading2,
    .subtitle {
      text-align: center !important;
    }
  }
`

const buttonContainerStyle = css`
  margin-top: 1rem;
`

const imageStyle = css`
  z-index: -1 !important;
  border-radius: 0.5rem;
`

const checkmarkStyle = css`
  transform: translate(-17px, 17px);
  z-index: 1;
  display: flex;
  margin-left: auto;
`

const whiteRectangleStyle = css`
  transform: translate(-60%, -150%);
  z-index: 1;

  @media screen and (max-width: ${breakpoints.medium - 1}px) {
    transform: translate(-30%, -150%);
  }
`

const blueRectangleStyle = css`
  transform: translate(-5rem, -1.25rem);
  z-index: 1;
`

const imageContainerStyle = css`
  position: relative;
`
